import { connect, MapDispatchToProps, MapStateToProps } from "react-redux";
import { State } from "redux/state";

import { ZenDeskProps, ZenDeskWidget } from "../components/ZenDeskWidget";

type DispatchProps = {};
type OwnProps = Pick<ZenDeskProps, "apiUrl" | "zendeskKey">;
type StateProps = Pick<ZenDeskProps, "credentials">;

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = () => {
    return {};
};

const mapStateToProps: MapStateToProps<StateProps, OwnProps, State> = (state: State) => {
    return {
        credentials: state.auth.credentials
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ZenDeskWidget);
